document.addEventListener("DOMContentLoaded",(function(){document.addEventListener("click",(function(e){var t=e.target;if(t.closest(".product_reviews_anchor")||t.classList.contains(".product_reviews_anchor")){var o=document.querySelector("#reviews_tab_button");if(o){var n=o.offsetTop;scroll({top:n,behavior:"smooth"});var c=new Event("click",{bubbles:!0});o.dispatchEvent(c)}}}))}));


$(document).ready(function () {
  $('body').on('click','.open_quick_modal', function(e) {
    e.preventDefault();
    $('body').addClass('active_quick_modal');
    var quick_add_modal = $(this).closest('.ProductItem').next('.quick_add_modal'); 
    var cloneModal = quick_add_modal.clone(true);
    cloneModal.addClass('clone_modal');
    $('body').append(cloneModal);
    cloneModal.addClass('active');
  });

  $('body').on('click','.close_quick_add_modal', function(e) {
    e.preventDefault();
    $('body').removeClass('active_quick_modal');
    $(this).closest('.quick_add_modal').removeClass('active');
    setTimeout(function() {
      $(this).closest('.quick_add_modal').remove();
    },500);



  });

  $('body').on('change','.ProductItem__MainSelect', function(e) {
    e.preventDefault();

    var val = $(this).val();
    var submitFormBtn = $(this).closest('form').find('.ProductForm__AddToCart');
    var form_error = $(this).closest('form').find('.slidecart-form-error');
    if(form_error.length) {
    	form_error.remove();
    }
                                     
    
    var activeOption = $(this).find('option:selected');
    var isAvailable = activeOption.attr('data-variant-available');
    if(isAvailable == 'true') {
    submitFormBtn.trigger('click');
    } else {
    	var form = $(this).closest('form');
      form.append('<div class="error slidecart-form-error">' + window.languages.soldout_grid_text + '</div>');
    }
  });
  
   $('body').on('click','.quick_add_modal  .ProductForm__Variants label', function(e) {
    e.preventDefault();
     var input = $(this).prev();
     input.trigger('click');
   });

  $('body').on('change','.quick_add_modal .ProductForm__Option [type="radio"]', function(e) {
    e.preventDefault();

    var form =  $(this).closest('form');
    var main_select = form.find('.main_select');
    var active_options = '';

    form.find('[type="radio"]:checked').each(function () {
      var val = $(this).val();
      active_options = active_options + val + " / ";
    });
    active_options = active_options.slice(0,-3);

    main_select.find('option').each(function () {
      var optionVal = $(this).text();
      if(optionVal == active_options) {

        var val = $(this).val();
        main_select.val(val);
        main_select.trigger('change');
      } 
    });


  });

  $('body').on('change','.quick_add_modal .main_select', function(e) {
    e.preventDefault();

    var self = $(this);
    var quick_add_modalEl = self.closest('.quick_add_modal');

        var items = [];
 
      var variant_id = self.val() * 1;
      var variant_obj =  {
        quantity:1,
        id:variant_id
      };
      items.push(variant_obj);
 
      var data_arr = {
        items: items
      };
 
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data_arr)
      }).then(function (response) {
        if (response.ok) {


              if($('body').hasClass('active_quick_modal')) {
      $('body').removeClass('active_quick_modal');
      $('.quick_add_modal.clone_modal').removeClass('active');
      setTimeout(function() {
        $('.quick_add_modal.clone_modal').remove();
      },500);

    }
          
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variant_id,
              quantity: 1
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
 
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];
            quick_add_modalEl.insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
          });
        }
      });

  });

  $('body').on('click', function(e) {
    var el = e.target;
    if($(el).hasClass('active_quick_modal')) {
      $(el).removeClass('active_quick_modal');
      $('.quick_add_modal.clone_modal').removeClass('active');
      setTimeout(function() {
        $('.quick_add_modal.clone_modal').remove();
      },500);

    }
  });

  $('body').on('change','.product_option_input', function(e) {
    e.preventDefault();

    debugger;
    var form =  $(this).closest('form');
    var main_select = form.find('.ProductItem__MainSelect');
    var active_options = '';
    var emptySelect = false;
    var ProductItemEl = form.closest('.ProductItem');
    
  var activeColorEl= ProductItemEl.find('.ProductItem__ColorSwatchList .SizeSwatch__Radio:checked');
    var activeColorVal;
    if(activeColorEl.length) {
       activeColorVal = activeColorEl.val();
    }
    form.find('.product_option_input:checked').each(function () {
      var val = $(this).val();

      if(val.length > 0) {
        active_options = active_options + val + " / ";
      } else {
        emptySelect = true;
      }
    });

    if(emptySelect == false) {
      active_options = active_options.slice(0,-3);
      if(activeColorVal) {
        active_options = active_options +  " / " + activeColorVal;
      }

      main_select.find('option').each(function () {
        var optionVal = $(this).text();
        if(optionVal == active_options) {
          var val = $(this).val();
          main_select.val(val);
          main_select.trigger('change');
        } 
      });
    }


  });

});